import React from 'react'
import PageIntro from '../../components/PageIntro/PageIntro'
import AllKybTable from '../../components/Table/client/AllKybTable'

const AllKyb = () => {
  return (
    <div className='mx-auto max-w-7xl space-y-6'>
      <PageIntro
        title={'KYB Verification'}
        description={'Review submitted business verification documents.'}
      />
      <AllKybTable />
    </div>
  )
}

export default AllKyb
